import React from 'react';
import { Instagram, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer id="kontakt" className="bg-black pt-16 sm:pt-24 pb-8 sm:pb-12 px-4 sm:px-6 lg:px-8" data-id="element-48">
      <div className="mx-auto max-w-7xl" data-id="element-49">
        {/* Section Header */}
        <div className="mb-10 sm:mb-16 text-center" data-id="element-50">
          <h2 className="text-2xl sm:text-3xl font-light text-white sm:text-4xl" data-id="element-51">
            Stopite v{' '}
            <span className="font-serif italic text-neutral-400" data-id="element-52">stik</span>
          </h2>
          <div className="mt-4 h-px w-24 bg-neutral-800 mx-auto" data-id="element-53"></div>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-6 mb-12 sm:mb-20" data-id="element-54">
          {/* Instagram */}
          <a href="https://www.instagram.com/dreambigslo/" target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-55">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-56">
              <Instagram className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-57" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-58">
              Instagram
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-59">
              @dreambigslo
            </span>
          </a>

          {/* Phone */}
          <a href="tel:+38651247570" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-60">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-61">
              <Phone className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-62" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-63">
              Telefon
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-64">
              051 247 570
            </span>
          </a>

          {/* Email */}
          <a href="mailto:info@dreambig.si" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-65">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-66">
              <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-67" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-68">
              E-pošta
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-69">
              info@dreambig.si
            </span>
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center pt-6 sm:pt-8 border-t border-neutral-900" data-id="element-70">
          <p className="text-xs sm:text-sm text-neutral-500" data-id="element-71">
            &copy; {new Date().getFullYear()} DREAMBIG Photography. Vse pravice
            pridržane.
          </p>
        </div>
      </div>
    </footer>;
}